<template>
    <main>
        <!-- breadcrumb-area-start -->
        <div class="it-breadcrumb-area it-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/breadcrumb/breadcrumb.png)' }">
            <div class="container">
                <div class="row ">
                    <div class="col-md-12">
                        <div class="it-breadcrumb-content z-index-3 text-center">
                            <div class="it-breadcrumb-title-box">
                                <h3 class="it-breadcrumb-title">Infrastructure</h3>
                            </div>
                            <div class="it-breadcrumb-list-wrap">
                                <div class="it-breadcrumb-list">
                                    <span><a href="#">home</a></span>
                                    <span class="dvdr">//</span>
                                    <span>Infrastructure</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- breadcrumb-area-end -->

        <div class="it-sv-details-area pt-120 pb-120">
            <div class="container">
                <div class="row">
                    <div class="col-xl-8 col-lg-8">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="it-sv-details-top-content mb-50">
                                    <h4 class="it-sv-details-title">Infrastructure in Details</h4>
                                    <p><a href="" target="_blank">Click to Download</a></p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
export default {
    name: "InfraView"
};
</script>
